module.exports = __webpack_public_path__ + "img/92164.339d15ca.svg";